import { useSession } from '@faststore/sdk'
import { Suspense, useEffect, useRef, useState } from 'react'
import { RenderClient } from 'src/components/RenderClient'
import { useCart } from 'src/sdk/cart/useCart'
import { useCarousel } from 'src/sdk/ui/useCarousel'
import './clerkioshelf-new.css'
import { ProductAddedMessage } from './ProductAddedMessage'
import { getCarouselDataValue } from './utils'

const ClerkioShelf = ({
  dataTemplate,
  isModal,
  marginTop,
  marginBottom,
  productLogic,
  content,
  showCarousel = true,
  isPDP = false,
}: {
  dataTemplate: string
  isModal?: boolean
  marginTop?: string
  marginBottom?: string
  productLogic?: string
  content?: string
  showCarousel?: boolean
  isPDP?: boolean
}) => {
  const { person } = useSession()
  const { id } = useCart()
  const carouselWrapper = useRef<HTMLDivElement>(null)
  const [hasBeenInitialized, setHasBeenInitialized] = useState(false)
  const { resizeWindow, carouselInitialization, addedProductName, isVisible } =
    useCarousel()

  useEffect(() => {
    if (id && showCarousel && !hasBeenInitialized) {
      carouselInitialization(carouselWrapper)
      setHasBeenInitialized(true)
    }

    return () => {
      window.removeEventListener('resize', resizeWindow)
    }
  }, [id, showCarousel])

  return (
    <>
      <Suspense fallback={null}>
        <RenderClient>
          <ProductAddedMessage
            isVisible={isVisible}
            addedProductName={addedProductName}
          />
        </RenderClient>
      </Suspense>
      <div
        id={content}
        className={`flex flex-col gap-2 ${
          !isModal && isPDP
            ? 'body-max-width:-mx-[calc((100vw-1520px)/2-8px)]'
            : ''
        }`}
        style={
          !isModal
            ? {
                background: '#F8F9FA',
                marginTop: marginTop,
                marginBottom: marginBottom,
              }
            : {}
        }
        ref={carouselWrapper}
      >
        <Suspense fallback={null}>
          <RenderClient>
            <span
              className="clerk"
              id={dataTemplate}
              data-template={dataTemplate}
              {...getCarouselDataValue(productLogic, content, person?.email)}
            ></span>
          </RenderClient>
        </Suspense>
      </div>
    </>
  )
}

export default ClerkioShelf
